exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".attachment[data-v-f2174e3e]{height:46px;border-radius:5px}.pointer[data-v-f2174e3e]{cursor:pointer}", ""]);

// exports
